<template lang="html">
  <div>
    <v-list dense nav>
      <v-list-item v-for="navItem in navList" :key="navItem.item" :to="navItem.link">
        <v-list-item-icon>
          <v-icon>{{ navItem.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{navItem.item}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <!-- ADMIN AND LOGIN BUTTONS -->
      <v-list-item v-if="getUser != null && getUserStatus" to="/Admin" class="accent">
        <v-list-item-icon>
          <v-icon color="white">fas fa-users-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">
           Admin Toolbox
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      </v-list-item>
      <!-- BADGE INDICATING NUMBER OF EVENTS DISPLAYED AS SUBMITTED BUT NOT PENDING, COMPLETED OR APPROVED -->
      <v-badge
        :content="getNumSubs.length"
        color="accent"
        inline
      >
        <v-list-item @click="logUser()">
          <v-list-item-icon>
            <v-icon v-if="getUser == null">fas fa-sign-in-alt</v-icon>
            <v-icon v-else>fas fa-sign-out-alt</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
            {{ getUser == null ? "Admin Login" : "Logout"}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-badge>
    </v-list>
  </div>
</template>

<script>
export default {
  data(){
    return {
      showNav: true
    }
  },
  methods: {
    logUser(){
      if (this.getUser == null){
        this.$router.push('/Login')
      }
      else {
        this.$store.dispatch('logout')
        this.$router.push("/")
      }
    }
  },
  computed: {
    checkSize(){
      if (this.$vuetify.breakpoint.mdAndUp === true){
        this.showNav = true
      }
      else {
        this.showNav = false
      }
    },
    getNumSubs(){
      return this.$store.getters.getSubmissions.filter(sub => sub.status =="Submitted")
    },
    getUser(){
      return this.$store.getters.getUser
    },
    getUserStatus(){
      let usr = this.getUser
      let allUsers = this.$store.getters.getUserList
      return allUsers.filter(user => user.email == usr)[0].status
    },
    navList(){
      return this.$store.getters.getNav
    }
  }
}
</script>

<style lang="css" scoped>
</style>
